const routerArr = [
  {
      path: '/login',
      name: 'login',
      meta: { title:'登录',login:false },
      component: () => import(/* webpackChunkName: 'shjd' */ './page/logIn.vue'),
  },
]
export default routerArr